import * as React from "react";

import { createSvgIcon } from "@mui/material/utils";

const Achievement5Icon = createSvgIcon(
    <svg
        width="160"
        height="160"
        viewBox="0 0 160 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10 87.8743V24.5169C10 21.8422 11.7704 19.4905 14.3407 18.7509L77.2876 0.636655C78.7332 0.220659 80.2668 0.220657 81.7124 0.636653L144.659 18.7509C147.23 19.4905 149 21.8422 149 24.5169V87.8744C149 102.989 141.575 117.14 129.136 125.728L82.9091 157.646C80.8572 159.063 78.1428 159.063 76.0909 157.646L29.8636 125.728C17.4254 117.14 10 102.989 10 87.8743Z"
            fill="url(#paint0_linear_5305_1592)"
        />
        <g filter="url(#filter0_i_5305_1592)">
            <path
                d="M24 81.4965V36.5146C24 33.841 25.769 31.49 28.338 30.7494L77.838 16.4791C78.9239 16.1661 80.0761 16.1661 81.162 16.4791L130.662 30.7494C133.231 31.49 135 33.841 135 36.5146V81.4965C135 96.5978 127.588 110.737 115.168 119.328L82.9133 141.639C80.8595 143.06 78.1405 143.06 76.0867 141.639L43.8317 119.328C31.4121 110.737 24 96.5978 24 81.4965Z"
                fill="url(#paint1_linear_5305_1592)"
            />
        </g>
        <path
            d="M24 81.4965V36.5146C24 33.841 25.769 31.49 28.338 30.7494L77.838 16.4791C78.9239 16.1661 80.0761 16.1661 81.162 16.4791L130.662 30.7494C133.231 31.49 135 33.841 135 36.5146V81.4965C135 96.5978 127.588 110.737 115.168 119.328L82.9133 141.639C80.8595 143.06 78.1405 143.06 76.0867 141.639L43.8317 119.328C31.4121 110.737 24 96.5978 24 81.4965Z"
            stroke="#AEAEAE"
            strokeWidth="3"
        />
        <g filter="url(#filter1_d_5305_1592)">
            <path
                d="M58.2065 59.634C58.9402 58.1475 61.0598 58.1475 61.7935 59.634L65.4125 66.9669C65.7038 67.5572 66.267 67.9664 66.9184 68.061L75.0108 69.2369C76.6512 69.4753 77.3063 71.4912 76.1192 72.6483L70.2635 78.3562C69.7921 78.8157 69.577 79.4777 69.6883 80.1265L71.0707 88.1862C71.3509 89.82 69.636 91.066 68.1688 90.2946L60.9307 86.4893C60.348 86.183 59.652 86.183 59.0693 86.4893L51.8312 90.2946C50.364 91.066 48.6491 89.82 48.9293 88.1862L50.3117 80.1265C50.423 79.4777 50.2079 78.8157 49.7365 78.3562L43.8808 72.6483C42.6937 71.4912 43.3488 69.4753 44.9892 69.2369L53.0816 68.061C53.733 67.9664 54.2962 67.5572 54.5875 66.9669L58.2065 59.634Z"
                fill="white"
            />
            <path
                d="M58.8789 59.9658C59.3088 59.0948 60.5004 59.0404 61.0254 59.8027L61.1211 59.9658L64.7402 67.2988C65.1158 68.0598 65.8198 68.6015 66.6445 68.7734L66.8105 68.8037L74.9033 69.9795C75.8642 70.1194 76.284 71.235 75.7217 71.9697L75.5957 72.1113L69.7402 77.8193C69.1326 78.4116 68.8346 79.2485 68.9258 80.0859L68.9492 80.2529L70.3311 88.3135C70.4949 89.2705 69.5639 90.0146 68.6914 89.707L68.5176 89.6309L61.2793 85.8252C60.5283 85.4305 59.6401 85.4055 58.8721 85.751L58.7207 85.8252L51.4824 89.6309C50.6226 90.0829 49.6269 89.4264 49.6504 88.501L49.6689 88.3135L51.0508 80.2529C51.1941 79.4165 50.9431 78.5642 50.377 77.9404L50.2598 77.8193L44.4043 72.1113C43.7088 71.4334 44.025 70.2834 44.9121 70.0195L45.0967 69.9795L53.1895 68.8037C54.0291 68.6817 54.7622 68.1792 55.1807 67.4482L55.2598 67.2988L58.8789 59.9658Z"
                stroke="#AEAEAE"
                strokeWidth="1.5"
            />
        </g>
        <g filter="url(#filter2_d_5305_1592)">
            <path
                d="M98.2065 59.634C98.9402 58.1475 101.06 58.1475 101.793 59.634L105.413 66.9669C105.704 67.5572 106.267 67.9664 106.918 68.061L115.011 69.2369C116.651 69.4753 117.306 71.4912 116.119 72.6483L110.264 78.3562C109.792 78.8157 109.577 79.4777 109.688 80.1265L111.071 88.1862C111.351 89.82 109.636 91.066 108.169 90.2946L100.931 86.4893C100.348 86.183 99.652 86.183 99.0693 86.4893L91.8312 90.2946C90.364 91.066 88.6491 89.82 88.9293 88.1862L90.3117 80.1265C90.423 79.4777 90.2079 78.8157 89.7365 78.3562L83.8808 72.6483C82.6937 71.4912 83.3488 69.4753 84.9892 69.2369L93.0816 68.061C93.733 67.9664 94.2962 67.5572 94.5875 66.9669L98.2065 59.634Z"
                fill="white"
            />
            <path
                d="M98.8789 59.9658C99.3088 59.0948 100.5 59.0404 101.025 59.8027L101.121 59.9658L104.74 67.2988C105.116 68.0598 105.82 68.6015 106.645 68.7734L106.811 68.8037L114.903 69.9795C115.864 70.1194 116.284 71.235 115.722 71.9697L115.596 72.1113L109.74 77.8193C109.133 78.4116 108.835 79.2485 108.926 80.0859L108.949 80.2529L110.331 88.3135C110.495 89.2705 109.564 90.0146 108.691 89.707L108.518 89.6309L101.279 85.8252C100.528 85.4305 99.6401 85.4055 98.8721 85.751L98.7207 85.8252L91.4824 89.6309C90.6226 90.0829 89.6269 89.4264 89.6504 88.501L89.6689 88.3135L91.0508 80.2529C91.1941 79.4165 90.9431 78.5642 90.377 77.9404L90.2598 77.8193L84.4043 72.1113C83.7088 71.4334 84.025 70.2834 84.9121 70.0195L85.0967 69.9795L93.1895 68.8037C94.0291 68.6817 94.7622 68.1792 95.1807 67.4482L95.2598 67.2988L98.8789 59.9658Z"
                stroke="#AEAEAE"
                strokeWidth="1.5"
            />
        </g>
        <defs>
            <filter
                id="filter0_i_5305_1592"
                x="22.5"
                y="14.7444"
                width="118"
                height="133.46"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="4" dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_5305_1592"
                />
            </filter>
            <filter
                id="filter1_d_5305_1592"
                x="38.2747"
                y="52.5191"
                width="45.4507"
                height="44.0096"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1592"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1592"
                    result="shape"
                />
            </filter>
            <filter
                id="filter2_d_5305_1592"
                x="78.2747"
                y="52.5191"
                width="45.4507"
                height="44.0096"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1592"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1592"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_5305_1592"
                x1="10"
                y1="0"
                x2="168.978"
                y2="141.565"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFF7EF" />
                <stop offset="1" stopColor="#D5D4D3" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5305_1592"
                x1="24"
                y1="16"
                x2="150.711"
                y2="125.882"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F4F4F4" />
                <stop offset="1" stopColor="#CDCDCA" />
            </linearGradient>
        </defs>
    </svg>,
    "Achievement5Icon",
);

export default Achievement5Icon;
